export default __webpack_public_path__ + "static/media/nftDetailBg.efca796d.png";